import { Component } from '@angular/core';
import { BaseBPWizardFormComponent, PROFILE_ATTRIBUTES_FORM } from '../base-bp-wizard-form.component';
import { StateService, TransitionService } from '@uirouter/angular';
import { BPWizardService, PAYMENT_TERMS_DEFAULT } from '../bp-wizard.service';
import { BPProfilesService } from '../../bp-profiles.service';
import { BPProfilesDataService } from '../../bp-profiles-data.service';
import { GaValidateService } from '../../../../shared/formly/ga-validate.service';
import { FormlyInputType, GaFormlyService, IExtraFieldConfigurationObject } from '../../../../shared/formly/ga-formly.service';
import { TextComponent } from '../../../../shared/text/text.component';
import { TranslationService } from '../../../../shared/translation/translation.service';
import { BPProfilesTCDataService } from '../../advanced/tc/bp-profiles-tc-data.service';

@Component({
  selector: 'bp-wizard-payment-terms',
  template: `
    <h2 [class.step-complete]="stepComplete"><text key="HEADING"></text></h2>
    <formly [form]="form" [model]="model" [fields]="fields"></formly>
  `
})
export class BPWizardPaymentTermsComponent extends BaseBPWizardFormComponent {
  constructor(
    private translationService:TranslationService,
    private formlyService:GaFormlyService,
    transitionService:TransitionService,
    bpWizardService:BPWizardService,
    bpProfilesService:BPProfilesService,
    bpProfilesDataService:BPProfilesDataService,
    validateService:GaValidateService,
    stateService:StateService,
    bpProfilesTCDataService:BPProfilesTCDataService
  ) {
    super(transitionService, bpWizardService, bpProfilesService, bpProfilesDataService, validateService, stateService, bpProfilesTCDataService);
    // marked as TC form
    this.formType = PROFILE_ATTRIBUTES_FORM;
  }

  protected createFields():IExtraFieldConfigurationObject[] {
    return [
      this.formlyService.aCustom()
        .withoutWrapper()
        .withComponent(TextComponent)
        .withWrapperClass('margin-bottom-md')
        .withExtraOptions({
          templateOptions: {
            inputs: {
              key: 'PAYMENTTERMS'
            }
          }
        })
        .build(),
      this.formlyService.anInput('paymentTerms')
        .withInputType(FormlyInputType.NUMBER)
        .withLabelClass(this.labelClass)
        .withValueClass('col-sm-2')
        .withAddOn(this.translationService.instant('GA.GENERAL.DAYS'))
        .withExtraOptions({
          templateOptions: {
            min: 0,
            max: 90
          }
        })
        .build(),
      this.formlyService.aTextarea('paymentTermsComment', 'GA.GENERAL.COMMENTS')
        .withLabelClass(this.labelClass)
        .withValueClass(this.valueClass)
        .withHideExpression(() => !this.model.paymentTerms && this.model.paymentTerms !== 0 || this.model.paymentTerms >= PAYMENT_TERMS_DEFAULT)
        .build()
    ];
  }
}